import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48778aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "app" }, null, -1))
const _hoisted_2 = { class: "fade-in" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-black-600 p-6 font-semibold" }, " Be the best nurse with this fully-featured app for community nurses! For mobile devices and the Web. Under Construction. ", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-items justify-center" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "email",
    name: "email",
    id: "username",
    class: "border py-2 px-3 text-grey-darkest w-full opacity-90",
    placeholder: "email"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex align-items justify-center" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "password",
    name: "password",
    id: "password",
    class: "border py-2 px-3 text-grey-darkest w-full opacity-90",
    placeholder: "password"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-11 font-bold text-blue-600" }, [
  /*#__PURE__*/_createElementVNode("p", null, "username: guest@guest.com password: guest123# ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "copy" }, [
  /*#__PURE__*/_createTextVNode(" © 2023 Solon Papageorgiou. Designed and Developed by "),
  /*#__PURE__*/_createElementVNode("a", { href: "http://gexl.eu" }, "Gexl")
], -1))

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/vue";

import router from "@/router";
 
import { useCounterStore } from "../store.ts";
import { storeToRefs } from "pinia";

import  axios  from 'axios';

import { onMounted } from 'vue'

import { login } from '../composables/login'




export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

function checkLogin() {


  const usr = document.querySelector("input[name=email]").value;
  
  const pass = document.querySelector("input[name=password]").value;

 const routeTrue = login(store, usr, pass);

  if (routeTrue === true) {
    router.push("/app");
  }

}

const store = useCounterStore();
const { credentials } = store;



//https://api.coindesk.com/v1/bpi/currentprice.json

      //alert(response.data.posts[0].name

      onMounted(() => {


        const parsedUrl = new URL(window.location.href);
const url = parsedUrl.origin;

let baseUrl = "";

console.log(baseUrl);

if (url.includes("localhost")) {

  baseUrl = 'http://127.0.0.1:8000/login';

}

else {

  baseUrl = 'https://api.communitynurse.eu/login';

}

        //axios.get('http://localhost:8000/login').then((response: any) => ( info = response.data.posts )   );
      // axios.get('http://127.0.0.1:8000/login').then((response: any) => ( /**alert(response.data.users[0].email)**/store.info = response.data.users )   );

//axios.get('http://192.168.10.8:8000/login').then((response: any) => ( /**alert(response.data.users[0].email)**/store.info = response.data.users )   );
axios.get(baseUrl).then((response: any) => ( /**alert(response.data.users[0].email)**/store.info = response.data.users )   );
         
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(credentials))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                id: "login-button",
                style: {"position":"absolute","left":"2px"},
                class: "block bg-green-400 hover:bg-green-500 text-white text-lg p-2 rounded",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {checkLogin();})
              }, " Login ")
            ]),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      _hoisted_8
    ])
  ], 64))
}
}

})